import type { Detections } from "@/features/presets/preset"
import type { Messages } from "@/libs/i18n"

export const DEVIATION_TYPE = {
  PITCH: "pitch",
  YAW: "yaw",
  ROLL: "roll",
} as const
export type DeviationType = (typeof DEVIATION_TYPE)[keyof typeof DEVIATION_TYPE]

export const getFaceAngleDeviationMessageKey = (
  deviationType?: string,
  rotation?: NonNullable<Detections["face"]>["rotation"],
):
  | keyof Messages[
      | "face_180_live_video"
      | "face_live_video"
      | "hair_live_video"]["face_angle_deviation"]
  | null => {
  if (!rotation || !deviationType) return null

  switch (deviationType as DeviationType) {
    case DEVIATION_TYPE.PITCH:
      return rotation.pitch > 0 ? "pitch_up" : "pitch_down"
    case DEVIATION_TYPE.YAW:
      return rotation.yaw > 0 ? "yaw_right" : "yaw_left"
    case DEVIATION_TYPE.ROLL:
      return rotation.roll > 0 ? "roll_counter_clockwise" : "roll_clockwise"
  }

  return null
}
